import React, { useEffect, useState } from "react";
import "./App.css";
import Search from "./Asset/search.png";
import TnLogo from "./Asset/tamilnadu-govt-logo.png";
// import faqlogo from "./Asset/FAQ(3).jpg";
import BootstrapCarousel from "react-bootstrap/Carousel";

import firstSlideimage from "./Asset/image5.jpg";
import secondSlide from "./Asset/thanjavurr2.jpg";
import thirdslideimage from "./Asset/teaestate.jpg";
import lastslideimg from "./Asset/agri.jpg";
import frlastslide from "./asserts/bgimg-1.jpg";
import Menu from "./Asset/menu.svg";
import Cross from "./Asset/cross.svg";

import "./components/landing.css";
import "./custom.css";
// import "./components/media.css";
import chatbotIcon from "./asserts/tn_travel.png";
import { useRef, useCallback } from "react";
import bgimg from "./asserts/bgimg-1.jpg";
import bgimg2 from "./asserts/bgimg-2.jpg";
import bgimg3 from "./asserts/bgimg-4.jpg";
// import { io } from "socket.io-client"; // Replaced with REST API
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import sendIcon from "./asserts/send.png";
import micIcon from "./asserts/micIcon.png";
import muteIcon from "./asserts/muteIcon.png";
import typingloader from "./asserts/Typing.gif";
import layoutImg from "./asserts/dragon1.jpg";
import layoutImg2 from "./asserts/dragon2.webp";
import female from "./asserts/female.jpg";
import male from "./asserts/male.png";
import others from "./asserts/others.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faToggleOn,
  faToggleOff,
  faL,
  faMicrophone,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import audioSample from "./asserts/sampleaudio.mp3";
import { ReactMic } from "react-mic";
import { useSpeechRecognition } from "react-speech-kit";
import { saveAs } from "file-saver";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
// import Carousel from "react-multi-carousel";
import MultiCarousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MainMenu from "./Asset/Icon/menu.png";
import MainMenuHover from "./Asset/Icon/menu_hover.png";
import Language from "./Asset/Icon/prime_language.png";
import LanguageHover from "./Asset/Icon/prime_language_hover.png";
import SeeMore from "./Asset/Icon/arrow-left.png";
import SeeMoreHover from "./Asset/Icon/arrow-left_hover.png";
import ViewInfo from "./Asset/Icon/mingcute_eye-line.png";
import ViewInfoHover from "./Asset/Icon/mingcute_eye-line_hover.png";
import Accommodation from "./Asset/Icon/mdi_bed-outline.png";
import AccommodationHover from "./Asset/Icon/mdi_bed-outline_hover.png";
import Restaurants from "./Asset/Icon/ri_hotel-line.png";
import RestaurantsHover from "./Asset/Icon/ri_hotel-line_hover.png";
import Support from "./Asset/Icon/ix_support.png";
import SupportHover from "./Asset/Icon/ix_support_hover.png";
import Itinerary from "./Asset/Icon/hugeicons_note-edit.png";
import ItineraryHover from "./Asset/Icon/hugeicons_note-edit_hover.png";
import Place from "./Asset/Icon/maps-arrow-diagonal.png";
import PlaceHover from "./Asset/Icon/maps-arrow-diagonal_hover.png";
import TopPlace from "./Asset/Icon/duo-icons_location.png";
import TopPlaceHover from "./Asset/Icon/duo-icons_location_hover.png";
import VirtualTour from "./Asset/Icon/fluent-mdl2_video-360-generic.png";
import VirtualTourHover from "./Asset/Icon/fluent-mdl2_video-360-generic_hover.png";
import Clock from "./Asset/Icon/clock.png";
import ClockHover from "./Asset/Icon/clock_hover.png";
import Visit from "./Asset/Icon/car.png";
import VisitHover from "./Asset/Icon/car.png";
import Feedback from "./Asset/Icon/codicon_feedback.png";
import FeedbackHover from "./Asset/Icon/codicon_feedback_hover.png";

import ImageHover from "./ImageHover";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './i18n';
import { useTranslation } from 'react-i18next';

const CustomLeftArrow = ({ onClick }) => {
  return (
    <button onClick={onClick} className="custom-left-arrow">
      <FaChevronLeft className="" />
    </button>
  );
};

var settings = {
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const CustomRightArrow = ({ onClick }) => {
  return (
    <button onClick={onClick} className="custom-right-arrow">
      <FaChevronRight />
    </button>
  );
};

// ============ API CONFIGURATION ============
const RASA_SERVER_URL = process.env.REACT_APP_RASA_SERVER_URL;
const INITIAL_INTENT = "/greet";

// ============ HELPER FUNCTIONS ============
const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
};

const generateUserId = () => `web_user_${Date.now()}`;

// Maps backend payload intents to UI icons
const ICON_MAP = {
  'main_menu': { primary: MainMenu, hover: MainMenuHover },
  'show_more_menu': { primary: SeeMore, hover: SeeMoreHover },
  'change_language': { primary: Language, hover: LanguageHover },
  'see_more': { primary: SeeMore, hover: SeeMoreHover },
  'ask_destination_details': { primary: ViewInfo, hover: ViewInfoHover },
  'ask_top_places': { primary: TopPlace, hover: TopPlaceHover },
  'ask_how_to_visit': { primary: Visit, hover: VisitHover },
  'ask_best_time': { primary: Clock, hover: ClockHover },
  'ask_nearby_attractions': { primary: Place, hover: PlaceHover },
  'ask_accommodation': { primary: Accommodation, hover: AccommodationHover },
  'ask_restaurant': { primary: Restaurants, hover: RestaurantsHover },
  'ask_customer_care': { primary: Support, hover: SupportHover },
  'create_itinerary': { primary: Itinerary, hover: ItineraryHover },
  'ask_virtual_tour': { primary: VirtualTour, hover: VirtualTourHover },
  'provide_feedback': { primary: Feedback, hover: FeedbackHover },
};

// Extract intent from Rasa payload 
const extractIntentFromPayload = (payload) => {
  if (!payload || typeof payload !== 'string') return null;

  // Remove leading slash and extract intent before any parameters
  const intent = payload.replace(/^\//, '').split(/[{\s]/)[0].trim();
  return intent || null;
};

const NO_ICON_TITLES = new Set(['back']);

const getButtonIcon = (payload, title = '') => {
  const lowerTitle = title.toLowerCase().trim();
  // Skip icon for explicitly excluded button titles
  if (NO_ICON_TITLES.has(lowerTitle)) {
    return title;
  }
  if (title.includes('\u274C')) {
    return title;
  }

  let intent = extractIntentFromPayload(payload);

  // Map the backend see_more button payload
  if (
    (intent === "select_category" ||
      intent === "ask_accommodation" ||
      intent === "ask_packages" ||
      intent === "show_boating_options" ||
      intent === "ask_virtual_tour" ||
      intent === "ask_top_places" ||
      intent === "ask_nearby_attractions" ||
      intent === "show_hotel_rooms") &&
    payload &&
    payload.includes("results_offset")
  ) {
    intent = "see_more";
  }

  const iconConfig = intent ? ICON_MAP[intent] : null;

  if (iconConfig) {
    return (
      <ImageHover
        key={title || intent}
        title={title}
        primarySrc={iconConfig.primary}
        secondarySrc={iconConfig.hover}
      />
    );
  }

  // return title;
  return <ImageHover title={title} />
};

// Helper function to extract YouTube video ID from various URL formats
const extractYouTubeId = (url) => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=)([a-zA-Z0-9_-]+)/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]+)/,
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]+)/,
    /(?:youtube\.com\/v\/)([a-zA-Z0-9_-]+)/
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  return null;
};

// Helper function to extract video info from message text
const extractVideoInfo = (text) => {
  const urlMatch = text.match(/(https?:\/\/[^\s]+)/);
  const url = urlMatch ? urlMatch[1] : null;
  const videoId = url ? extractYouTubeId(url) : null;

  return { url, videoId, hasVideo: !!videoId };
};

// Platform detection function
const detectPlatform = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for mobile platforms
  if (/android/i.test(userAgent)) {
    return { source: "android", platform: "mobile" };
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return { source: "ios", platform: "mobile" };
  }

  // Default to web
  return { source: "web", platform: "desktop" };
};

// ============ RASA SERVICE CLASS ============
class RasaService {
  constructor(userId, location = null) {
    this.userId = userId;
    this.location = location;
    this.userIp = null; // cached on first send
  }

  async getUserIp() {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const json = await res.json();
      return json.ip || null;
    } catch {
      return null;
    }
  }

  async sendMessage(message) {
    try {
      // Detect platform fresh each time
      const platformInfo = detectPlatform();

      // Fetch user IP (cached after first call)
      const userIp = await this.getUserIp();

      const requestData = {
        sender: this.userId,
        message: message,
        session_persistence: true,
        metadata: {
          source: platformInfo.source,
          platform: platformInfo.platform,
          ip: userIp,
          latitude: this.location?.latitude,
          longitude: this.location?.longitude,
          district: this.location?.district || null,
          state: this.location?.state || null,
        }
      };

      console.info("[chatbot] sending webhook request:", requestData);

      const response = await fetch(RASA_SERVER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      console.info("[chatbot] webhook response status:", response.status);

      if (!response.ok) throw new Error("Failed to connect");
      const data = await response.json();
      return this.parseResponse(data);
    } catch (error) {
      console.error("[chatbot] webhook error:", error);
      throw new Error("Failed to connect to chatbot");
    }
  }

  parseResponse(data) {
    const messages = [];
    data.forEach((botResponse, index) => {
      // The UI expects all content to be wrapped inside a 'text' object for bot messages
      const messageData = {};

      // Handle quick reply buttons & regular buttons - Map to quick_replies for UI compatibility
      if (botResponse.buttons && botResponse.buttons.length > 0) {
        messageData.quick_replies = botResponse.buttons.map((btn) => ({
          content_type: "text",
          title: btn.title || "",
          payload: btn.payload || "",
          type: btn.type || "postback", // Add type for web_url buttons
          url: btn.url || "", // Add url for web_url buttons
        }));
      }

      // Handle quick_replies (native format)
      if (botResponse.quick_replies && botResponse.quick_replies.length > 0) {
        messageData.quick_replies = botResponse.quick_replies;
      }

      // Handle carousel/template attachments
      // Handle carousel/template attachments - FLATTEN payload for UI compatibility
      if (
        botResponse.attachment &&
        botResponse.attachment.type === "template" &&
        botResponse.attachment.payload &&
        botResponse.attachment.payload.elements
      ) {
        messageData.attachment = {
          type: "template",
          elements: botResponse.attachment.payload.elements
        };
      } else if (botResponse.attachment && botResponse.attachment.type === "image") {
        // Normalize image attachment to use 'elements' array as expected by UI
        const imgSrc = botResponse.attachment.payload ? botResponse.attachment.payload.src : botResponse.image;
        console.log("[RasaService] Image attachment detected:", { imgSrc, attachment: botResponse.attachment });
        if (imgSrc) {
          messageData.attachment = {
            type: "image",
            elements: [{ image_url: imgSrc }]
          };
        }
      } else if (botResponse.image) {
        // Handle direct image property
        console.log("[RasaService] Direct image property detected:", botResponse.image);
        messageData.attachment = {
          type: "image",
          elements: [{ image_url: botResponse.image }]
        };
      } else if (botResponse.attachment) {
        // Other attachments (video, etc) - Keep original structure as some use payload directly
        messageData.attachment = botResponse.attachment;
        if (botResponse.image) {
          messageData.image = botResponse.image;
        }
      }

      // Handle custom JSON payload 
      if (botResponse.custom) {
        messageData.custom = botResponse.custom;
      }

      const message = {
        sender: "bot",
        receive: "bot",
        text: botResponse.text || "", // Always valid string
        data: messageData,            // Structured data
        time: formatTime(new Date()),
        timestamp: Date.now() + index, // Ensure unique timestamp for each message
      };

      console.log("[RasaService] Parsed message:", message);

      // Only add valid messages
      if (
        message.text ||
        messageData.quick_replies ||
        messageData.attachment ||
        messageData.image ||
        messageData.custom
      ) {
        messages.push(message);
      }
    });
    return messages;
  }
}

const RASA_LANG_MAP = {
  'english': 'en',
  'tamil': 'ta',
  'hindi': 'hi',
  'telugu': 'te',
  'malayalam': 'ml',
};

const Chatbot = () => {
  const { t, i18n } = useTranslation();
  // const [isWebSocketOpen, setIsWebSocketOpen] = useState(false); // Replaced with REST API
  // const [openSecondScript, setpenSecondScript] = useState(false);/
  const [show, setShow] = useState(false);
  const dotIconDivRef = useRef(null);
  const newConRef = useRef(null);

  const buttonRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [chatbotOpen, setChatbotOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState("");
  const containerRef = useRef(null);
  const [displayDay, setDisplayDay] = useState("");
  const [messages, setMessages] = useState([]);
  // const [socket, setSocket] = useState(null); // Replaced with REST API
  // const socketUrl = "https://ttdc.skeintech.com/"; // Using RASA_SERVER_URL constant instead
  const [isActive, setIsActive] = useState(false);
  const [currentTime, setCurrentTime] = useState([]);
  const [paymentLinkClicked, setPaymentLinkClicked] = useState(false);
  const [connectionError, setConnectionError] = useState("");
  const [connectionStatus, setConnectionStatus] = useState(false);
  const [isNewConv, setIsNewConv] = useState(false);
  const [selectedButtonIndex, setSelectedButtonIndex] = useState();
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [locationError, setLocationError] = useState(null);
  const [audioData, setAudioData] = useState();
  const [audioOpen, setAudioOpen] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [interimTranscript, setInterimTranscript] = useState("");
  const [audioFileData, setAudioFileData] = useState();

  // input button
  const [isShow, setIsShow] = useState(false); // show or hide the message box after sending a message.
  const [interimText, setInterimText] = useState("");
  const [listening1, setListening1] = useState(false);
  const [recognition, setRecognition] = useState(null);
  const [lang, setLang] = useState("en-US");
  const [ogData, setOgData] = useState("");
  const [toggleHide, setToggleHide] = useState(true);

  const [disableData, setDisableData] = useState(true);
  const [newConvbody, setNewConvbody] = useState(true);

  // ============ DATE PICKER STATES ============
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dpStartDate, setDpStartDate] = useState(null);
  const [dpEndDate, setDpEndDate] = useState(null);
  const [dpCancelPayload, setDpCancelPayload] = useState(null);

  const toTitleCase = (str) =>
    str ? str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : str;

  const capsToTitleCase = (str) =>
    str ? str.replace(/\b[A-Z]{2,}(?:\s+[A-Z]{2,})*\b/g, (match) =>
      match.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())
    ) : str;

  // ============ NEW API INTEGRATION STATES ============
  const rasaServiceRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const [selectedButtons, setSelectedButtons] = useState({});
  const [lastSentTimestamp, setLastSentTimestamp] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  const carouselRef = useRef(null);
  const [carouselIndexMap, setCarouselIndexMap] = useState({});

  const [currentcarouselIndex, setCurrentcarouselIndex] = useState(0);
  const carouselRefs = useRef({});
  const getIndex = (key) => carouselIndexMap[key] || 0;

  const setIndex = (key, value) => {
    setCarouselIndexMap((prev) => ({
      ...prev,
      [key]: typeof value === "function" ? value(prev[key] || 0) : value,
    }));
  };

  const scrollCarousel = (direction, totalItems, messageKey) => {
    const el = carouselRefs.current[messageKey];
    if (!el) return;

    const card = el.children[0];
    if (!card) return;

    const gap = 16;
    const cardWidth = card.getBoundingClientRect().width + gap;

    // update index FIRST (logic)
    setIndex(messageKey, (prevIndex) => {
      const maxIndex = totalItems - 1;
      const nextIndex = Math.min(
        Math.max(prevIndex + direction, 0),
        maxIndex
      );

      // scroll ONLY one card
      el.scrollTo({
        left: nextIndex * cardWidth,
        behavior: "smooth",
      });

      return nextIndex;
    });
  };



  function truncateText(text, maxChars) {
    if (text.length <= maxChars) {
      return text; // No need to truncate if the text is within the limit
    }
    return text.slice(0, maxChars) + '...';
  }

  const onResult = (result) => {
    setValue(result);
    setInterimTranscript(result);
    setTimeout(() => {
      setInput(result);
      // setInput(prev => `${prev} ${result}`);
      setInterimTranscript("");
    }, 2000);
    // setInput(prev => `${prev} ${result}`)
    // setValue((value)=>[...value,result]);
    // Check if the new value is already in the array
    //  if(value.length === 1){
    //   value?.map((valueData,index)=>{
    //     if(valueData === result){
    //       return value; // If it is, return the previous state unmodified
    //     }
    //     else{
    //       return [...value, result]; // Otherwise, add the new value to the array
    //     }
    //   })
    //  } else{
    //   return value; // If it is, return the previous state unmodified
    // }
    // setValue((value) => {
    //   if (value.includes(result)) {
    //     return value; // If it is, return the previous state unmodified
    //   }else{
    //     return [...value, result]; // Otherwise, add the new value to the array
    //   }
    // });
  };

  const onEnd = () => {
    setListening(false);
  };
  const startListening = () => {
    setListening(true);
    listen({ interimResults: true, lang: "en-IN" }); // Customize options here
  };
  const [value, setValue] = useState("");
  const [listening, setListening] = useState(false);
  const {
    listen,
    listening: isListening,
    stop,
  } = useSpeechRecognition({
    onResult,
    onEnd,
    // onResult: (result) => {
    //   setValue((value)=>[...value,result]);
    //   // setTimeout(() => {
    //     // setValue((value)=>[value.push(result)]);
    // // }, 2000);
    //   // setValue((value)=>
    //   //   [...value,result]
    //   // );
    // },
  });
  const [record, setRecord] = useState(false);

  const startRecording = useCallback(() => {
    setRecord(true);
  }, []);
  /**Animted start */

  const [displayedText, setDisplayedText] = useState([]);
  const text = "WELCOME TO TAMIL NADU TOURISM";
  const speed = 100; // Adjust speed as needed

  useEffect(() => {
    let isMounted = true;

    async function typeWriter() {
      for (let i = 0; i < text.length; i++) {
        if (!isMounted) break; // Clean up check
        setDisplayedText((prev) => [...prev, text.charAt(i)]);
        await new Promise((resolve) => setTimeout(resolve, speed));
      }
    }

    typeWriter();

    return () => {
      isMounted = false; // Cleanup on unmount
    };
  }, []);

  /**Animted end */
  const stopRecording = useCallback(() => {
    setRecord(false);
  }, []);

  const onData = useCallback((recordedBlob) => { }, []);

  const onStop = useCallback((recordedBlob) => {
    // convertBlobToText(recordedBlob.blob)

    const reader = new FileReader();
    reader.onload = () => {
      const audioData = reader.result;
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      // const audioContext = new (window.AudioContext);
      audioContext?.decodeAudioData(
        audioData,
        (buffer) => {
          const recognizer = new (window.webkitSpeechRecognition ||
            window.SpeechRecognition)();
          recognizer.lang = "en-US";
          recognizer.interimResults = false;
          recognizer.maxAlternatives = 1;

          recognizer.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            setTranscript(transcript);
          };

          recognizer.onerror = (event) => {
            console.error("Speech recognition error", event);
          };

          const audioBuffer = audioContext.createBufferSource();
          audioBuffer.buffer = buffer;
          audioBuffer.connect(audioContext.destination);

          const mediaStream = audioContext.createMediaStreamDestination();
          audioBuffer.connect(mediaStream);

          const mediaRecorder = new MediaRecorder(mediaStream.stream);
          mediaRecorder.start();

          audioBuffer.start(0);
          audioBuffer.onended = () => {
            mediaRecorder.stop();
          };

          mediaRecorder.ondataavailable = (e) => {
            recognizer.start();
          };
        },
        (error) => {
          console.error("Error decoding audio data", error);
        }
      );
    };

    reader.readAsArrayBuffer(recordedBlob.blob);
  }, []);

  const convertBlobToText = (blob) => {
    const reader = new FileReader();
    reader.onload = () => {
      const audioData = reader.result;
      const audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      // const audioContext = new (window.AudioContext);
      audioContext?.decodeAudioData(
        audioData,
        (buffer) => {
          const recognizer = new (window.webkitSpeechRecognition ||
            window.SpeechRecognition)();
          recognizer.lang = "en-US";
          recognizer.interimResults = false;
          recognizer.maxAlternatives = 1;

          recognizer.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            setTranscript(transcript);
          };

          recognizer.onerror = (event) => {
            console.error("Speech recognition error", event);
          };

          const audioBuffer = audioContext.createBufferSource();
          audioBuffer.buffer = buffer;
          audioBuffer.connect(audioContext.destination);

          const mediaStream = audioContext.createMediaStreamDestination();
          audioBuffer.connect(mediaStream);

          const mediaRecorder = new MediaRecorder(mediaStream.stream);
          mediaRecorder.start();

          audioBuffer.start(0);
          audioBuffer.onended = () => {
            mediaRecorder.stop();
          };

          mediaRecorder.ondataavailable = (e) => {
            recognizer.start();
          };
        },
        (error) => {
          console.error("Error decoding audio data", error);
        }
      );
    };

    reader.readAsArrayBuffer(blob);
  };

  const getLocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const coords = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              district: null,
              state: null,
            };
            try {
              const res = await fetch(
                `https://nominatim.openstreetmap.org/reverse?lat=${coords.latitude}&lon=${coords.longitude}&format=json`,
                { headers: { 'Accept-Language': 'en' } }
              );
              const data = await res.json();
              coords.district = data?.address?.state_district || null;
              coords.state = data?.address?.state || null;
            } catch {
              // reverse geocode failed — lat/lng still available
            }
            resolve(coords);
          },
          (error) => {
            reject(error);
          }
        );
      } else {
        reject(new Error("Geolocation not supported"));
      }
    });
  };

  // customData is no longer needed - location is passed directly to RasaService
  // const customData = {
  //   source: "mobile",
  //   session_persistence: true,
  //   platform: "web",
  //   latitude: location?.latitude,
  //   longitude: location?.longitude,
  // };

  const [currentIndexBot, setCurrentIndexBot] = useState(0);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const updateOnlineStatus = () => {
    setIsOnline(navigator.onLine);
  };

  useEffect(() => {
    if (paymentLinkClicked) {
      const newMessage = {
        sender: "user",
        receive: "bot",
        text: "PAYMENT SUCESSFUL",
        time: "",
      };

      // socket.emit("user_uttered", {
      //   reciepent_id: "",
      //   message: "payment done",
      //   customData,
      // });

      const timerOut = setTimeout(() => {
        handleButtonClick("PAYMENT SUCESSFUL", "PAYMENT SUCESSFUL");
        // setMessages((prevMessages)=>[...prevMessages,newMessage])
      }, 9000);
      //  clearTimeout(timerOut)

      //  setTimeout(()=>{ setPaymentLinkClicked(false)},1000)
    }
    // setPaymentLinkClicked(false)
  }, [paymentLinkClicked]);
  // Effect to add event listeners when the component mounts and clean up when it unmounts
  useEffect(() => {
    // Add event listeners for online and offline events
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [isOnline]);

  const handlePrev = (elements) => {
    setCurrentIndexBot(
      (prevIndex) => (prevIndex - 1 + elements.length) % elements.length
    );
  };
  const handleNext = (elements) => {
    setCurrentIndexBot((prevIndex) => (prevIndex + 1) % elements.length);
  };
  const actualTime = new Date();
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    // second: '2-digit',
    hour12: true, // Use 24-hour format
    // weekday: "long", // Add full weekday name
    // year: "numeric", // Add numeric year
    // month: "2-digit", // Add numeric month with two digits
    // day: "numeric", // Add numeric day
  };
  const actualTimeData = actualTime.toLocaleTimeString("en-US", options);

  useEffect(() => {
    const options = {
      weekday: "short", // Add abbreviated weekday name
      month: "short", // Add abbreviated month name
      day: "2-digit", // Add numeric day with two digits
    };

    const date = new Date();
    const displayDayDate = new Intl.DateTimeFormat("en-US", options).format(
      date
    );
    setDisplayDay(displayDayDate);
  }, []);

  const handleClick = (e) => {
    e.preventDefault(); // Prevent the default button behavior
    setIsActive(!isActive);
  };

  const [isToggled, setIsToggled] = useState(false);

  // Function to handle the toggle action
  const toggle = async () => {
    let toggleDetail = !isToggled;
    setDisableData(false);
    // setToggleHide(!toggleHide)
    if (toggleDetail) {
      try {
        const coords = await getLocation();
        setLocation(coords);
        setIsToggled(true);
        console.log("📍 Location enabled:", coords);

        // Always update RasaService with new coords so future messages carry them
        if (rasaServiceRef.current) {
          rasaServiceRef.current = new RasaService(rasaServiceRef.current.userId, coords);
        }

        // Send location to backend immediately if chat is already initialized
        if (rasaServiceRef.current && isNewConv) {
          const locationPayload = `/inform_location{"latitude": ${coords.latitude}, "longitude": ${coords.longitude}${coords.district ? `, "district": "${coords.district}"` : ''}${coords.state ? `, "state": "${coords.state}"` : ''}}`;
          console.log("📍 Sending location to backend:", locationPayload);
          console.log("📍 Coordinates:", coords);

          // Add user message indicating location was shared
          const locationMessage = {
            sender: "user",
            receive: "bot",
            text: "📍 Location shared",
            time: formatTime(Date.now()),
            isUser: true,
            timestamp: Date.now()
          };
          setMessages((prevMessages) => [...prevMessages, locationMessage]);

          // Show typing indicator
          setIsTyping(true);

          try {
            // Send location message to backend
            const botMessages = await rasaServiceRef.current.sendMessage(locationPayload);
            setIsTyping(false);

            // Add bot response messages
            for (const msg of botMessages) {
              setMessages((prevMessages) => [...prevMessages, msg]);
              if (botMessages.length > 1) {
                await new Promise((resolve) => setTimeout(resolve, 300));
              }
            }
          } catch (error) {
            console.error("📍 Error sending location to backend:", error);
            setIsTyping(false);
          }
        }
      } catch (error) {
        console.error("📍 Location error:", error);
        setLocation({ latitude: null, longitude: null, district: null, state: null });
        setIsToggled(false);
        // Optionally show an error message to the user
        alert("Unable to get your location. Please check your browser permissions.");
      }
    } else {
      setLocation({ latitude: null, longitude: null, district: null, state: null });
      setIsToggled(false);
      // Update RasaService so subsequent messages don't carry the old coordinates
      if (rasaServiceRef.current) {
        rasaServiceRef.current = new RasaService(rasaServiceRef.current.userId, null);
      }
    }
    setTimeout(() => setDisableData(true), 100);
  };

  const handlePaymentClick = () => {
    setPaymentLinkClicked(true);
  };

  useEffect(() => {
    messages?.map((message, msgIndex) => {
      if (message?.sender === "bot") {
        // if(message?.data?.quick_replies){
        //  const buttonLength =  message?.data?.quick_replies?.length
        //  if(buttonLength ===1){
        //   setSelectedButtonIndex()
        //  }

        // }
        if (message?.data?.attachment?.type === "template") {
          const elementsValue = message?.data?.attachment?.elements?.length;
          if (elementsValue === 1) {
            // message?.data?.attachment?.elements?.map((elementsData)=>{
            // })
            setCurrentIndexBot(0);
          }
        }
      }
    });
  }, [messages]);
  useEffect(() => {
    // ============ REST API INITIALIZATION ============
    const initChat = async () => {
      try {
        let userLocation = null;
        let initialPayload = INITIAL_INTENT; // Default is /greet

        // Only use location if already enabled by user toggle
        if (isToggled && location.latitude && location.longitude) {
          userLocation = location;
          // Use backticks for proper string interpolation
          initialPayload = `/inform_location{"latitude": ${userLocation.latitude}, "longitude": ${userLocation.longitude}${userLocation.district ? `, "district": "${userLocation.district}"` : ''}${userLocation.state ? `, "state": "${userLocation.state}"` : ''}}`;
          console.log("📍 Location enabled. Sending payload:", initialPayload);
        }

        // Create RasaService with coordinates 
        rasaServiceRef.current = new RasaService(generateUserId(), userLocation);

        setIsTyping(true);
        setConnectionStatus(false);

        // Send the calculated payload
        const botMessages = await rasaServiceRef.current.sendMessage(initialPayload);

        setIsTyping(false);

        for (const msg of botMessages) {
          setMessages((prevMessages) => [...prevMessages, msg]);
          if (botMessages.length > 1) {
            await new Promise((resolve) => setTimeout(resolve, 300));
          }
        }
      } catch (error) {
        console.error("[chatbot] initialization error:", error);
        setIsTyping(false);
        setConnectionStatus(true);
        setConnectionError("Chatbot is offline. Please try later.");
      }
    };

    // Initialize when new conversation starts
    if (isNewConv && !isInitialized) {
      setMessages([]);
      setSelectedButtons({});
      initChat();
      setIsInitialized(true);
      setShowDatePicker(false);
    }

    // Reset initialization when conversation changes
    if (!isNewConv) {
      setIsInitialized(false);
    }
  }, [isNewConv, isToggled, location]);

  const handleSend = async (e) => {
    setIsOpen(false);
    setListening1(false);
    if (recognition) {
      recognition.stop();
    }

    // Handle audio transcription
    if (value) {
      let fetchAudio = async () => {
        try {
          const response = await axios.post(
            "https://demo.emeetify.com:81/tourism/file/multipleLanguageAudio",
            { text: value },
            { responseType: "blob" } // Ensure the response is a Blob
          );

          var audioUrl = URL?.createObjectURL(response.data);
          setOgData(audioUrl);

          const newMessage = {
            sender: "bot",
            receive: "user",
            text: { type: "audio", audio_url: audioUrl },
            time: formatTime(Date.now()),
          };
          setMessages((prevMessages) => [...prevMessages, newMessage]);
          setAudioData(audioUrl);
          setValue("");
        } catch (error) {
          console.log(error);
        }
      };
      fetchAudio();
    }

    // Handle text message send via REST API
    if (input.trim()) {
      const now = Date.now();
      // Disable all existing buttons when user types a new message
      setLastSentTimestamp(now);

      const userMessage = {
        sender: "user",
        receive: "bot",
        text: input,
        time: formatTime(now),
        isUser: true,
        timestamp: now
      };

      // Add user message to chat
      setMessages((prevMessages) => [...prevMessages, userMessage]);

      const messageToSend = input;
      setInput("");
      setIsShow(false);

      // Show typing indicator
      setIsTyping(true);

      try {
        // Send message via REST API
        if (!rasaServiceRef.current) {
          rasaServiceRef.current = new RasaService(generateUserId(), location);
        }

        const botMessages = await rasaServiceRef.current.sendMessage(messageToSend);

        setIsTyping(false);

        // Add bot response messages
        for (const msg of botMessages) {
          const msgText = (msg.text || '').toString();
          const isShowDatePicker =
            msg.data?.custom?.type === 'show_date_picker' ||
            msg.data?.custom?.type === 'show_warn_date_picker';

          if (isShowDatePicker) {
            setDpStartDate(null);
            setDpEndDate(null);
            setDpCancelPayload(msg.data?.custom?.cancel_payload || null);
            setShowDatePicker(true);
            continue;
          }

          setMessages((prevMessages) => [...prevMessages, msg]);

          // Small delay between multiple messages
          if (botMessages.length > 1) {
            await new Promise((resolve) => setTimeout(resolve, 300));
          }
        }
      } catch (error) {
        console.error("[chatbot] send message error:", error);
        setIsTyping(false);

        // Add error message
        const errorMessage = {
          sender: "bot",
          receive: "user",
          text: `⚠️ ${error.message}`,
          time: formatTime(Date.now()),
          isError: true,
        };
        setMessages((prevMessages) => [...prevMessages, errorMessage]);
      }
    }
  };

  // ============ BUTTON CLICK HANDLER (REST API) ============
  const handleButtonClick = async (payload, title, messageIndex, type = "postback", url = "") => {
    // Handle Web URL buttons (Open in new tab)
    if (type === "web_url" && url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    // Track which button was selected for this message
    setSelectedButtons(prev => ({ ...prev, [messageIndex]: title }));
    // Disable buttons in all previous messages (only for postback, not web_url)
    setLastSentTimestamp(Date.now());

    // Add user message showing the button title
    const userMessage = {
      sender: "user",
      receive: "bot",
      text: title,
      time: formatTime(Date.now()),
      isUser: true,
      timestamp: Date.now(),
    };

    setMessages((prevMessages) => [...prevMessages, userMessage]);
    scrollToBottom();

    // Show typing indicator
    setIsTyping(true);

    try {
      // Send payload via REST API
      if (!rasaServiceRef.current) {
        rasaServiceRef.current = new RasaService(generateUserId(), location);
      }

      const botMessages = await rasaServiceRef.current.sendMessage(payload);

      setIsTyping(false);

      // Add bot response messages
      for (const msg of botMessages) {
        const msgText = (msg.text || '').toString();
        const isShowDatePicker =
          msg.data?.custom?.type === 'show_date_picker' ||
          msg.data?.custom?.type === 'show_warn_date_picker';
        if (isShowDatePicker) {
          setDpStartDate(null);
          setDpEndDate(null);
          setDpCancelPayload(msg.data?.custom?.cancel_payload || null);
          setShowDatePicker(true);
          continue;
        }

        setMessages((prevMessages) => [...prevMessages, msg]);

        // Small delay between multiple messages
        if (botMessages.length > 1) {
          await new Promise((resolve) => setTimeout(resolve, 300));
        }
      }
    } catch (error) {
      console.error("[chatbot] button click error:", error);
      setIsTyping(false);

      // Add error message
      const errorMessage = {
        sender: "bot",
        receive: "user",
        text: `⚠️ ${error.message}`,
        time: formatTime(Date.now()),
        isError: true,
      };
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
    }
  };

  const binaryDataFunction = (binaryData) => {
    // Decode binary data if needed
    // For example, if binaryData is in base64 format
    const decodedData = atob(binaryData);
    // Create an ArrayBuffer from the decoded data
    const arrayBuffer = new ArrayBuffer(decodedData.length);

    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }

    // Create an audio context
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();

    // Decode audio data into an audio buffer
    audioContext.decodeAudioData(arrayBuffer, (audioBuffer) => {
      // Now you have the audio buffer, you can play it or save it to a file
      // For example, saving it to a file using the File API
      const blob = new Blob([arrayBuffer], { type: "audio/wav" }); // Adjust the type according to your audio format
      const url = URL.createObjectURL(blob);
      // Create a link to download the audio file
      const a = document.createElement("a");
      a.href = url;
      a.download = "audio.wav"; // Adjust the filename and extension as needed
      document.body.appendChild(a);
      a.click();
    });
  };

  const blobFunction = async (bytes) => {
    let arrayBuffer;
    if (bytes instanceof Uint8Array) {
      arrayBuffer = bytes.buffer; // If bytes is a Uint8Array, get its underlying ArrayBuffer
    } else if (bytes instanceof ArrayBuffer) {
      arrayBuffer = bytes; // If bytes is already an ArrayBuffer, use it directly
    } else {
      throw new Error("Unsupported byte type");
    }

    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

    const blob = new Blob([arrayBuffer], { type: "audio/wav" }); // Adjust the type according to your audio format
    const localUrl = URL.createObjectURL(blob);
    //  setAudioUrl(localUrl);

    // Save to local file
    saveToLocalFile(blob);
  };
  const readBlobAsArrayBuffer = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  };

  const saveToLocalFile = (blob) => {
    const url = window.URL.createObjectURL(blob);
    // setLocalFilePath(url);
  };

  const handleAudioSend = () => {
    setAudioOpen(true);
  };

  /**
   * The scrollToBottom function scrolls the last element of a container into view smoothly.
   */
  /**
   * The scrollToBottom function scrolls the container to the bottom smoothly if it exists.
   */
  const scrollToBottom = () => {
    if (containerRef.current) {
      const lastElement = containerRef.current.lastElementChild;
      if (lastElement) {
        // Always scroll to the last message to ensure full visibility
        lastElement.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }
  };


  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // when the picker opens ensure it is visible by scrolling
  useEffect(() => {
    if (showDatePicker) {
      setTimeout(scrollToBottom, 100);
    }
  }, [showDatePicker]);

  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % image.length);
  };

  const prevSlide = () => {
    setCurrentIndex((currentIndex - 1 + image.length) % image.length);
  };
  const handleChatbotOpen = () => {
    if (chatbotOpen) {
      //   setTimeout(() => setChatbotOpen(false), 500);
      setChatbotOpen(false);
    } else {
      setChatbotOpen(true);
    }
  };
  const image = [
    {
      src: bgimg,
      alt: "no img",
    },
    {
      src: bgimg3,
      alt: "no img",
    },
    {
      src: bgimg2,
      alt: "no img",
    },
  ];

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  /**
   * The function `handleNewConOpen` toggles the value of `isOpen`.
   */
  const handleNewConOpen = () => {
    setIsOpen(!isOpen);
  };

  window.addEventListener("load", () => {
    const element = document.querySelector(".chating_header");
    element?.classList.add("animated");
  });
  const languageMap = {
    en: "en-US",
    ta: "ta-IN",
    te: "te-IN",
    ml: "ml-IN",
    hindi: "hi-IN",
  };
  useEffect(() => {
    // Initialize SpeechRecognition
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (SpeechRecognition) {
      const recognitionInstance = new SpeechRecognition();
      recognitionInstance.continuous = true;
      recognitionInstance.interimResults = true;
      recognitionInstance.lang = lang;

      recognitionInstance.onstart = () => {
        setListening1(true);
      };

      recognitionInstance.onend = () => {
        setListening1(false);
      };

      recognitionInstance.onresult = (event) => {
        let interimTranscript = "";
        let finalTranscript = "";

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscript += transcript + " ";
          } else {
            interimTranscript += transcript;
          }
        }

        setInput((prevText) => prevText + finalTranscript);
        setValue(finalTranscript);
        setInterimText(interimTranscript);
      };

      setRecognition(recognitionInstance);
    } else {
      alert("Speech Recognition API is not supported in this browser.");
    }
  }, [lang]);
  const handleStartStop = () => {
    console.log('listening1: ', listening1);

    if (listening1) {
      recognition.stop();
    } else {
      recognition.start();
    }
  };
  // slider
  const items = [
    {
      src: "https://media.istockphoto.com/id/1095885438/photo/the-bandra-worli-sea-link.jpg?s=1024x1024&w=is&k=20&c=VoTfOaohVt8OyE-_xSELqc1UKZ7d3Fwim3JAMYPKLV8=",
      description:
        "Tamil Nadu Tourism Policy -2023 The Introduction of Tamil Nadu's first-ever Tourism Policy represents a momentous milestone for the ...",
    },
    {
      src: "https://media.istockphoto.com/id/1095885438/photo/the-bandra-worli-sea-link.jpg?s=1024x1024&w=is&k=20&c=VoTfOaohVt8OyE-_xSELqc1UKZ7d3Fwim3JAMYPKLV8=",
      description:
        "Tamil Nadu Tourism Policy -2023 The Introduction of Tamil Nadu's first-ever Tourism Policy represents a momentous milestone for the ...",
    },
    {
      src: "https://media.istockphoto.com/id/1095885438/photo/the-bandra-worli-sea-link.jpg?s=1024x1024&w=is&k=20&c=VoTfOaohVt8OyE-_xSELqc1UKZ7d3Fwim3JAMYPKLV8=",
      description:
        "Tamil Nadu Tourism Policy -2023 The Introduction of Tamil Nadu's first-ever Tourism Policy represents a momentous milestone for the ...",
    },
    {
      src: "https://media.istockphoto.com/id/1095885438/photo/the-bandra-worli-sea-link.jpg?s=1024x1024&w=is&k=20&c=VoTfOaohVt8OyE-_xSELqc1UKZ7d3Fwim3JAMYPKLV8=",
      description:
        "Tamil Nadu Tourism Policy -2023 The Introduction of Tamil Nadu's first-ever Tourism Policy represents a momentous milestone for the ...",
    },
    {
      src: "https://media.istockphoto.com/id/1095885438/photo/the-bandra-worli-sea-link.jpg?s=1024x1024&w=is&k=20&c=VoTfOaohVt8OyE-_xSELqc1UKZ7d3Fwim3JAMYPKLV8=",
      description:
        "Tamil Nadu Tourism Policy -2023 The Introduction of Tamil Nadu's first-ever Tourism Policy represents a momentous milestone for the ...",
    },
  ];

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 40,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1,
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
  };

  // useEffect(() => {
  //   const loadRasaWebchatScript = () => {
  //     const script = document.createElement("script");
  //     script.src = "https://cdn.jsdelivr.net/npm/rasa-webchat/lib/index.js";
  //     script.async = true;
  //     script.onload = () => {
  //       try {
  //         let shouldLoadLiveAgent = false;

  //         // Initialize Rasa Webchat here
  //         window.WebChat.default(
  //           {
  //             customData: {
  //               latitude: "11.0168",
  //               longitude: "76.9558",
  //             },
  //             socketUrl: "https://ttdc.skeintech.com/",
  //             title: "Tamilnadu Tourism Bot",
  //             socketPath: "/rasa/socket.io",
  //             subtitle: "Bot",
  //             initPayload: "hi",
  //             params: {
  //               storage: "session", // Change to 'local' or 'session' as needed
  //             },
  //             styleOptions: {
  //               // Define your custom styles here
  //               bubbleBackground: "#2196F3",
  //               bubbleTextColor: "white",
  //               userBubbleBackground: "#4caf50",
  //               userBubbleTextColor: "white",
  //             },
  //             onSocketEvent: {
  //               bot_uttered: (res) => {
  //                 if (
  //                   res.text === "Live agent is connecting..." ||
  //                   res.text === "நேரடி முகவர் இணைக்கிறார்..."
  //                 ) {
  //                   check();
  //                   // shouldLoadLiveAgent = true;
  //                 }
  //               },
  //               // user_uttered: (res) => {
  //               // },
  //               // parse_data: {
  //               //   // Additional parsing data (if needed)
  //               // },
  //               // metadata: {
  //               //   session_persistence: true, // Enable session persistence
  //               // },
  //               // 'disconnect': () => doSomeCleanup(),
  //             },
  //           },
  //           null
  //         );

  //         // Check your condition here

  //         const check = () => {
  //           const liveAgentScript = document.createElement("script");
  //           liveAgentScript.type = "text/javascript";

  //           //     liveAgentScript.innerHTML = `
  //           //     window.__lc = window.__lc || {};
  //           //     window.__lc.license = 16092537;
  //           //     (function (n, t, c) {
  //           //      function i(n) {
  //           //       return e._h ? e._h.apply(null, n) : e._q.push(n);
  //           //      }
  //           //      var e = {
  //           //       _q: [],
  //           //       _h: null,
  //           //       _v: "2.0",
  //           //       on: function () {
  //           //        i(["on", c.call(arguments)]);
  //           //       },
  //           //       once: function () {
  //           //        i(["once", c.call(arguments)]);
  //           //       },
  //           //       off: function () {
  //           //        i(["off", c.call(arguments)]);
  //           //       },
  //           //       get: function () {
  //           //        if (!e._h)
  //           //         throw new Error("[LiveChatWidget] You can't use getters before load.");
  //           //        return i(["get", c.call(arguments)]);
  //           //       },
  //           //       call: function () {
  //           //        i(["call", c.call(arguments)]);
  //           //       },
  //           //       init: function () {
  //           //        var n = t.createElement("script");
  //           //        (n.async = !0),
  //           //         (n.type = "text/javascript"),
  //           //         (n.src = "https://cdn.livechatinc.com/tracking.js"),
  //           //         t.head.appendChild(n);
  //           //       }
  //           //      };
  //           //      !n.__lc.asyncInit && e.init(), (n.LiveChatWidget = n.LiveChatWidget || e);
  //           //     })(window, document, [].slice);
  //           //  `;
  //           liveAgentScript.innerHTML = `window.__lc = window.__lc || {};
  //           window.__lc.license = 18032838;
  //           window.__lc.integration_name = "manual_channels";
  //           ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice));
  //           `;
  //           document.head.appendChild(liveAgentScript);
  //         };
  //       } catch (error) {
  //         console.error("Error initializing WebChat:", error);
  //       }
  //     };
  //     script.onerror = (error) => {
  //       console.error("Error loading Rasa Webchat script:", error);
  //     };
  //     document.head.appendChild(script);
  //   };

  //   loadRasaWebchatScript();

  //   return () => {
  //     const scriptElement = document.querySelector(
  //       'script[src="https://cdn.jsdelivr.net/npm/rasa-webchat/lib/index.js"]'
  //     );
  //     if (scriptElement) {
  //       scriptElement.remove();
  //     }
  //     window.location.reload();
  //   };
  // }, []);

  const handleCLick = () => {
    setShow(!show);
  };

  const handleClickOutside = (event) => {
    if (
      dotIconDivRef.current &&
      !dotIconDivRef.current.contains(event.target) &&
      !newConRef.current
    ) {
      setIsOpen(false);

      if (newConRef.current) {
        newConRef.current.click(() => {
          setMessages([]);
          setIsOpen(false);
          setIsToggled(false);
          setIsInitialized(false);
          setIsNewConv(true); // This will trigger initChat via useEffect
        });
      }
    } else {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [newConRef]);

  return (
    //     <>
    //       <div className="new_super-header">
    //         <h3 className="new_animated-text">
    //           {displayedText.map((char, index) => (
    //             <span key={index} style={{ animationDelay: `${index * 5}s` }}>
    //               {char}
    //             </span>
    //           ))}
    //         </h3>
    //       </div>
    //       <nav className="new_header">
    //         <img className="ttd_icon_res" src={TnLogo} />
    //         <h2>TTDC</h2>
    //         <ul>
    //           <li className="new_list">Home <span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></span></li>
    //           <li className="new_list">Features</li>
    //           <li className="new_list">How it works</li>
    //           <li className="new_list">Pages <span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></span></li>
    //           <li className="new_list">Pricing</li>
    //           <li className="new_list">Blog <span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></span></li>
    //           <li className="new_list">Contact</li>
    //         </ul>
    //            <span>
    //         <svg className="menu_bar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg></span>

    //       </nav>
    //       <div className="list_container">
    //         <ul>
    //           <li className="new_list">Home <span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></span></li>
    //           <li className="new_list">Features</li>
    //           <li className="new_list">How it works</li>
    //           <li className="new_list">Pages <span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></span></li>
    //           <li className="new_list">Pricing</li>
    //           <li className="new_list">Blog <span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg></span></li>
    //           <li className="new_list">Contact</li>
    //         </ul>
    //         </div>
    //         <footer>
    //         <div class="footer-wave">
    //         <div class="wave-container">
    //   <div class="wave"></div>
    // </div>

    // </div>

    //         </footer>
    //     </>
    <div className="chat-body">
      <div className="chat-container">
        <div
          onClick={handleChatbotOpen}
          className={`rounded_div ${chatbotOpen ? "rounded_div_hide hide-div" : "rounded_div_show"
            }`}
        >
          {chatbotOpen ? (
            <div className="svg1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />
              </svg>
            </div>
          ) : (
            <div className="svg2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z" />
              </svg>
            </div>
          )}
        </div>
        <div className="chat-bot-div">
          {chatbotOpen ? (
            <div className="overall_chat">
              {newConvbody ? (
                <div className="initial_sub_header">
                  {" "}
                  {/* Sub Header Starts */}
                  <div className="flex-grows">
                    <h5 className="chating_header_h6">
                      Start a conversation with our team of experts now!
                    </h5>
                    {/* <div className="initial_div_img">
                      <img src={male} />
                      <img src={female} />
                      <img src={others} />
                    </div> */}
                  </div>
                  <button
                    className="initial_content_btn"
                    onClick={() => {
                      setIsToggled(false);
                      setIsInitialized(false);
                      setIsNewConv(!isNewConv);
                      setNewConvbody(false);
                    }}
                  >
                    New Conversation
                  </button>
                  {/* Sub Header Ends */}{" "}
                </div>
              ) : (
                ""
              )}

              {isNewConv ? (
                <>
                  <div className="overall_allign">
                    <div className="main_header">
                      <div className="header_allign">
                        <button
                          className="button"
                          onClick={() => {
                            setIsNewConv(!isNewConv);
                            setNewConvbody(true);
                          }}
                        >
                          <svg
                            className="svg_btn"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
                          </svg>
                        </button>
                        <div className="image_content_wrapper">
                          <img src={chatbotIcon} className="ttdc_icon" alt="" />

                          <div className="wrap_text">
                            <h5 className="initial_title">Travel TN</h5>
                            <p className="initial_text">I am Here to Help you</p>
                          </div>
                        </div>
                        <div
                          className="dot_icon_div button-dot"
                          // type="button"
                          id="dropdownMenuButton"
                          aria-haspopup="true"
                          aria-expanded="false"
                        //     style={{}}
                        //onClick={() => setIsOpen(!isOpen)}
                        // onMouseEnter={() => setIsOpen(true)}
                        // onMouseLeave={()=> setIsOpen(false)}
                        >
                          <button className="button-dot">
                            {/* <p class="dot_icons">...</p> */}
                            <svg
                              className=" dot_icon kebab_icon"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 128 512"
                            >
                              <path d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z" />
                            </svg>
                          </button>

                          <div
                            aria-labelledby="dropdownMenuButton"
                            className={
                              disableData
                                ? "conversation_allign"
                                : "display-none-card"
                            }

                          //onMouseLeave={() => setIsOpen(!isOpen)}
                          >
                            <div className="conversation2"></div>
                            <div className="conversation">
                              <div>
                                <div className="conversation_highlight">
                                  <span>
                                    <svg
                                      className="convo_svg"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 512 512"
                                    >
                                      <path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z" />
                                    </svg>
                                  </span>
                                  <div
                                    onClick={() => {
                                      setInput("")
                                      setMessages([]);
                                      setSelectedButtons({});
                                      setTimeout(() => setDisableData(true), 100);
                                      setDisableData(false);
                                      setIsOpen(true);
                                      setIsToggled(false);
                                      setIsInitialized(false);
                                      // Trigger new conversation by toggling isNewConv
                                      setIsNewConv(false);
                                      setTimeout(() => {
                                        setIsNewConv(true);
                                        setDisableData(true);
                                      }, 100);
                                    }}
                                  >
                                    <p className="p_tag_margin_remover">
                                      New Conversation
                                    </p>
                                  </div>
                                </div>
                                <div className="underline underline_center">
                                  <hr className="underline" />
                                </div>
                                <div className="location_allign_mainchatnew">
                                  <p className="newsss">
                                    <span>
                                      <svg
                                        className="location_allign"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 384 512"
                                      >
                                        <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                                      </svg>
                                    </span>
                                    Location
                                  </p>
                                  <button
                                    onClick={toggle}
                                    className={`toggle-icon newsss_button  ${isToggled ? "green" : "gray"
                                      }`}
                                  >
                                    <FontAwesomeIcon
                                      icon={isToggled ? faToggleOn : faToggleOff}
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div onClick={handleChatbotOpen} className="svg1">
                          <svg
                            className="closer_icon"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                          >
                            <path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />
                          </svg>
                        </div>
                      </div>
                      {/* <div className="chating_sub_header">
                      <p className="allign_active chating_active">
                        &nbsp;{" "}
                        <svg
                          className="inactive_svg"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                        </svg>
                        &nbsp; #101020
                      </p>
                      {/* <div>
      <textarea
        value={value}
        onChange={(e)=>setValue(e.target.value)}
      />
      <button onMouseDown={listen} onMouseUp={stop}>
        🎤
      </button>
      {listening && <div>Go ahead I'm listening</div>}
    </div> */}
                      {/* <div>
      <ReactMic
        record={record}
        className="sound-wave"
        onStop={onStop}
        onData={onData}
        strokeColor="#000000"
        backgroundColor="#FF4081"
      />
      <button onClick={startRecording} type="button">Start</button>
      <button onClick={stopRecording} type="button">Stop</button>
    </div> 
                    </div> */}
                    </div>

                    <div className="wifi_status">
                      {connectionStatus || !isOnline ? (
                        <div className="chating_connection_inactive">
                          <span className="material-symbols-outlined wifi_icon"></span>{" "}
                          &nbsp;
                          <p className="no-internet-connectivity-text">
                            {" "}
                            No Internet Connectivity
                          </p>
                        </div>
                      ) : (
                        <div className="chating_connection_active">
                          <p className="back-to-online-text">Online</p>
                        </div>
                      )}
                    </div>
                    <div className="main_body">
                      <div
                        ref={containerRef}
                        className="chating_body chating_body_new"
                      >
                        <div className="chating_date">
                          <p className="chating_day">{displayDay}</p>
                        </div>
                        {messages?.map((message, index) => (
                          <>
                            {message?.sender === "bot" ? (
                              <div key={index} className="left_allign">
                                <div className="chat_icon_responsive_div">
                                  <img
                                    src={chatbotIcon}
                                    alt="icon"
                                    className="chat_icon_responsive"
                                  />
                                </div>

                                {/* <div className="bot_message_container_for_img"> */}
                                {/* {message?.data?.attachment?.type ===*/}

                                {/* {message?.data?.attachment?.type ===
                                      "template" ? (
                                        <div className="carousel-elements">
                                                  ?.elements,"=====>")}
                                          <button
                                            onClick={() => {
                                              handlePrev(
                                                message?.data?.attachment
                                                  ?.elements
                                              );
                                            }}
                                            className={
                                              message?.data?.attachment
                                                ?.type === "template" &&
                                              message?.data?.attachment
                                                ?.elements?.length > 1
                                                ? `carousel-button-elements left`
                                                : "carousel-btn-none"
                                            }
                                          >
                                            {"<"}
                                          </button>
                                          <div className="carousel-content-elements">
                                            {message?.data?.attachment?.elements?.map(
                                              (elementsData, elementIndex) => (
                                                <div
                                                  key={elementIndex}
                                                  className={`carousel-item-elements ${
                                                    elementIndex ===
                                                    currentIndexBot  
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  style={
                                                    
                                                    {
                                                    transform: `translateX(-${
                                                      currentIndexBot * 100 
                                                    }%)`,
                                                  }
                                           }
                                                >
                                                  <img
                                                    src={
                                                      elementsData?.image_url
                                                    }
                                                    className="elements-payload-img"
                                                    alt=""
                                                  />
                                                  <h3 className="elementPayload-title">
                                                    {elementsData?.title}
                                                  </h3>
                                                  <p className="elementPayload-subtitle">
                                                    {elementsData?.subtitle}
                                                  </p>
                                                  {elementsData?.buttons?.map(
                                                    (
                                                      elementsButton,
                                                      elementsButtonIndex
                                                    ) => (
                                                      <button
                                                        key={
                                                          elementsButtonIndex
                                                        }
                                                        className="btn-bot-reply"
                                                        onClick={(e) => {
                                                          const newMessage = {
                                                            sender: "user",
                                                            receive: "bot",
                                                            text: elementsButton?.title,
                                                          };
                                                          scrollToBottom();

                                                          setMessages(
                                                            (prevMessages) => [
                                                              ...prevMessages,
                                                              newMessage,
                                                            ]
                                                          ); //   setMessages((prevMessages) => [...prevMessages, { sender: 'bot', text: "123456" }]);
                                                          socket.emit(
                                                            "user_uttered",
                                                            {
                                                              reciepent_id: "",
                                                              message:
                                                                elementsButton?.payload,
                                                              customData,
                                                            }
                                                          );
                                                        }}
                                                      >
                                                        {elementsButton?.title}
                                                      </button>
                                                    )
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                          <button
                                            onClick={() => {
                                              handleNext(
                                                message?.data?.attachment
                                                  ?.elements
                                              );
                                            }}
                                            className={
                                              message?.data?.attachment
                                                ?.type === "template" &&
                                              message?.data?.attachment
                                                ?.elements?.length > 1
                                                ? "carousel-button-elements right"
                                                : "carousel-btn-none"
                                            }
                                          >
                                            {">"}
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )} */}

                                {message?.data?.attachment?.type === "image" && message?.data?.attachment?.elements ? (
                                  <div className="breaking">
                                    <div className="bot_message_container">
                                      {message?.data?.attachment?.elements?.map(
                                        (imageData, imageIndex) => (
                                          <div
                                            key={imageIndex}
                                            className="chating_right_cover"
                                          >
                                            <img
                                              src={imageData?.image_url}
                                              className="image-style"
                                              alt="Image"
                                            />
                                          </div>
                                        )
                                      )}
                                    </div>
                                    <div>
                                      <span className="chating_right_cover_span">
                                        {message?.time}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {message?.data?.type === "audio" ? (
                                  <div className="breaking">
                                    <div className="bot_message_container">
                                      {/* <div className="chating_right_cover"> */}
                                      <audio className="audio-control" controls>
                                        <source
                                          src={message?.data?.audio_url}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                      {/* </div> */}
                                    </div>
                                    <div>
                                      <span className="chating_right_cover_span">
                                        {message?.time}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {message?.data?.attachment?.type === "video" ? (
                                  // message?.data?.attachment?.payload
                                  <div className="breaking">
                                    <div className="bot_message_container">
                                      <div className="chating_right_cover">
                                        <video className="video-content" controls>
                                          <source
                                            src={
                                              message?.data?.attachment?.payload
                                                ?.src
                                            }
                                            type="video/mp4"
                                          />
                                        </video>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {message?.data?.attachment?.type === "payment" ? (
                                  <div className="chating_right_cover">
                                    <div className="link-url-div">
                                      <a
                                        target="blank"
                                        className="link_style"
                                        href={message?.data?.attachment?.elements}
                                        onClick={() => {
                                          handlePaymentClick();
                                        }}
                                      >
                                        {message?.data?.attachment?.elements}
                                      </a>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {message?.data?.attachment?.type === "map" ? (
                                  <div className="bot_message_container">
                                    <div className="chating_right_cover">
                                      <div className="link-url-div">
                                        {message?.data?.attachment?.elements?.map(
                                          (mapData, mapDataIndex) => (
                                            <a
                                              key={mapDataIndex}
                                              className="link_style"
                                              target="blank"
                                              href={mapData?.web_url}
                                            >
                                              {mapData?.web_url}
                                            </a>
                                          )
                                        )}
                                      </div>
                                    </div>
                                    <div>
                                      <span className="chating_right_cover_span">
                                        {message?.time}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {/* {message?.data?.attachment?.type === "template" ? (
                            <div className="breaking">
                              <div className="bot_message_container">
                                <div className="chating_right_cover">
                                  <div className="carousel-elements">
                                    <button
                                      onClick={() => {
                                        handlePrev(
                                          message?.data?.attachment?.elements
                                        );
                                      }}
                                      className={
                                        message?.data?.attachment?.type ===
                                          "template" &&
                                        message?.data?.attachment?.elements
                                          ?.length > 1
                                          ? `carousel-button-elements left`
                                          : "carousel-btn-none"
                                      }
                                    >
                                      {"<"}
                                    </button>
                                    <div className="carousel-content-elements">
                                      {message?.data?.attachment?.elements?.map(
                                        (elementData, elementIndex) => (
                                          <div
                                            key={elementIndex}
                                            style={{
                                              transform: `translateX(-${
                                                currentIndexBot * 100
                                              }%)`,
                                            }}
                                            className={`carousel-item-elements ${
                                              elementIndex === currentIndexBot
                                                ? "active-card"
                                                : "carousel-btn-none"
                                            }`}
                                          >
                                            <img
                                              src={elementData?.image_url}
                                              alt="elements_image"
                                              className="inside_layout_img"
                                            />
                                            <h5>{elementData?.title}</h5>
                                            <p>{elementData?.subtitle}</p>
                                            {elementData?.buttons?.map(
                                              (buttonData, buttonIndex) => (
                                                <button
                                                  key={buttonIndex}
                                                  className={`chatbot_message_subbtn_inactive button-2 ${
                                                    isActive ? "active" : ""
                                                  }`}
                                                  onClick={(e) => {
                                                    const newMessage = {
                                                      sender: "user",
                                                      receive: "bot",
                                                      text: buttonData?.title,
                                                    };
                                                    scrollToBottom();

                                                    setMessages(
                                                      (prevMessages) => [
                                                        ...prevMessages,
                                                        newMessage,
                                                      ]
                                                    ); //   setMessages((prevMessages) => [...prevMessages, { sender: 'bot', text: "123456" }]);
                                                    socket.emit(
                                                      "user_uttered",
                                                      {
                                                        reciepent_id: "",
                                                        message:
                                                          buttonData?.payload,
                                                        customData,
                                                      }
                                                    );
                                                  }}
                                                >
                                                  {buttonData?.title}
                                                </button>
                                              )
                                            )}
                                          </div>
                                        )
                                      )}
                                    </div>

                                    <button
                                      onClick={() => {
                                        handleNext(
                                          message?.data?.attachment?.elements
                                        );
                                      }}
                                      className={
                                        message?.data?.attachment?.type ===
                                          "template" &&
                                        message?.data?.attachment?.elements
                                          ?.length > 1
                                          ? "carousel-button-elements right"
                                          : "carousel-btn-none"
                                      }
                                    >
                                      {">"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <span className="chating_right_cover_span">
                                  {message?.time}
                                </span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )} */}

                                {/* {message?.data?.attachment?.type === "template" ? (
                            <div className="breaking">
                              <div className="bot_message_container">
                                <div className="chating_right_cover">
                                  <div className="carousel-elements">
                                    <button
                                      onClick={() => {
                                        handlePrev(
                                          message?.data?.attachment?.elements
                                        );
                                      }}
                                      className={
                                        message?.data?.attachment?.type ===
                                          "template" &&
                                        message?.data?.attachment?.elements
                                          ?.length > 1
                                          ? `carousel-button-elements left`
                                          : "carousel-btn-none"
                                      }
                                    >
                                      {"<"}
                                    </button>
                                    <div className="carousel-content-elements">
                                      {message?.data?.attachment?.elements?.map(
                                        (elementData, elementIndex) => (
                                          <div
                                            key={elementIndex}
                                            style={{
                                              transform: `translateX(-${
                                                currentIndexBot * 100
                                              }%)`,
                                            }}
                                            className={`carousel-item-elements ${
                                              elementIndex === currentIndexBot
                                                ? "active-card"
                                                : ""
                                            }`}
                                          >
                                            <img
                                              src={elementData?.image_url}
                                              alt="elements_image"
                                              className="inside_layout_img"
                                            />
                                            <h5>{elementData?.title}</h5>
                                            <p>{elementData?.subtitle}</p>
                                            {elementData?.buttons?.map(
                                              (buttonData, buttonIndex) => (
                                                <button
                                                  key={buttonIndex}
                                                  className={`chatbot_message_subbtn_inactive button-2 ${
                                                    isActive ? "active" : ""
                                                  }`}
                                                  onClick={(e) => {
                                                    const newMessage = {
                                                      sender: "user",
                                                      receive: "bot",
                                                      text: buttonData?.title,
                                                    };
                                                    scrollToBottom();

                                                    setMessages(
                                                      (prevMessages) => [
                                                        ...prevMessages,
                                                        newMessage,
                                                      ]
                                                    ); //   setMessages((prevMessages) => [...prevMessages, { sender: 'bot', text: "123456" }]);
                                                    socket.emit(
                                                      "user_uttered",
                                                      {
                                                        reciepent_id: "",
                                                        message:
                                                          buttonData?.payload,
                                                        customData,
                                                      }
                                                    );
                                                  }}
                                                >
                                                  {buttonData?.title}
                                                </button>
                                              )
                                            )}
                                          </div>
                                        )
                                      )}
                                    </div>

                                    <button
                                      onClick={() => {
                                        handleNext(
                                          message?.data?.attachment?.elements
                                        );
                                      }}
                                      className={
                                        message?.data?.attachment?.type ===
                                          "template" &&
                                        message?.data?.attachment?.elements
                                          ?.length > 1
                                          ? "carousel-button-elements right"
                                          : "carousel-btn-none"
                                      }
                                    >
                                      {">"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <span className="chating_right_cover_span">
                                  {message?.time}
                                </span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )} */}

                                {message?.data?.attachment?.type ===
                                  "template" ? (
                                  <div
                                    className="carousel-bot-container"
                                    style={{
                                      boxShadow:
                                        message?.data?.attachment?.elements
                                          ?.length === 1 && "none",
                                    }}
                                  >
                                    {Array.isArray(
                                      message?.data?.attachment?.elements
                                    ) &&
                                      message?.data?.attachment?.elements?.length >
                                      1 ? (
                                      <div>
                                        {getIndex(message.timestamp) > 0 && (
                                          <CustomLeftArrow className="carousel-bot-nav left" onClick={() => scrollCarousel(-1, message?.data?.attachment?.elements?.length, message.timestamp)} />
                                        )}

                                        <div className="carousel-bot-track" ref={(el) => {
                                          carouselRefs.current[message.timestamp] = el;
                                        }}>
                                          {message?.data?.attachment?.elements?.map((item, index) => (
                                            <div className="carousel-bot-item-content" key={index}>
                                              <div className="carousel-bot-img-wrap">
                                                <img className="carousel-bot-item-img" src={item?.image_url} alt={item?.title} />

                                                {item?.availability && (
                                                  <span
                                                    className={`availability-badge ${item.availability?.includes("\u274C")
                                                      ? "availability-badge--unavailable"
                                                      : "availability-badge--available"
                                                      }`}
                                                  >
                                                    <span className="availability-badge__icon">
                                                      {item.availability?.includes("\u274C") ? "\u2717" : "\u2713"}
                                                    </span>
                                                    {item.availability.replace(/[\u274C\u2705]/gu, "").trim()}
                                                  </span>
                                                )}

                                              </div>
                                              {item?.city && (
                                                <p className="carousel-city">
                                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className="carousel-city-icon"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" /></svg>
                                                  {item.city}
                                                </p>
                                              )}

                                              <p className="new_title">{toTitleCase(item?.title)}</p>

                                              {!item?.price && !item?.additional_amt && (
                                                <div className="description">{capsToTitleCase(item.subtitle)}</div>
                                              )}
                                              {(item?.price || item?.additional_amt || item?.max_guest_count) && (
                                                <div className="carousel-price-row">
                                                  <div className="carousel-price-info">
                                                    {item?.price && <span className="carousel-price">{item.price}</span>}
                                                    {item?.additional_amt && (
                                                      <span className="carousel-extra-guest">+₹{item.additional_amt} Extra Guest</span>
                                                    )}
                                                  </div>
                                                  {item?.max_guest_count && (
                                                    <span className="carousel-guest-badge">👥 {item.max_guest_count} {item.guest_label}</span>
                                                  )}
                                                </div>
                                              )}

                                              <div className="chatbot_message_btn">
                                                {item?.buttons?.map((buttonData, buttonIndex) => {
                                                  const isSelected = selectedButtons[message.timestamp] === buttonData.title;
                                                  const isAnySelected = selectedButtons[message.timestamp] !== undefined || message.timestamp <= lastSentTimestamp;
                                                  return (
                                                    <button
                                                      key={buttonIndex}
                                                      className={`chatbot_message_subbtn_inactive button-2  carousel-bot-btn ${isSelected ? "active" : ""}`}
                                                      onClick={() =>
                                                        handleButtonClick(
                                                          buttonData?.payload,
                                                          buttonData?.title,
                                                          message.timestamp,
                                                          buttonData?.type,
                                                          buttonData?.url
                                                        )
                                                      }
                                                    // disabled={isAnySelected}
                                                    >
                                                      {getButtonIcon(buttonData?.payload, buttonData?.title)}
                                                      {/* {truncateText(buttonData?.title, 23)} */}

                                                    </button>
                                                  )
                                                })}
                                              </div>
                                            </div>
                                          ))}
                                        </div>

                                        {getIndex(message.timestamp) < message.data.attachment.elements.length - 1 && (
                                          <CustomRightArrow className="carousel-bot-nav right" onClick={() => scrollCarousel(1, message?.data?.attachment?.elements?.length, message.timestamp)} />
                                        )}
                                      </div>

                                    ) : (
                                      <>
                                        {Array.isArray(
                                          message?.data?.attachment?.elements
                                        ) &&
                                          message?.data?.attachment?.elements
                                            ?.length === 1 &&
                                          message?.data?.attachment?.elements?.map(
                                            (item, index) => (
                                              <div
                                                className="carousel-bot-item new-carousal_hide"
                                                key={index}
                                              >
                                                <div className="carousel-bot-img-wrap">
                                                  <img
                                                    className="new-carousal_image"
                                                    src={item?.image_url}
                                                    alt={`Image ${index + 1}`}
                                                  />

                                                  {item?.availability && (
                                                    <span
                                                      className={`availability-badge ${item.availability?.includes("\u274C")
                                                        ? "availability-badge--unavailable"
                                                        : "availability-badge--available"
                                                        }`}
                                                    >
                                                      <span className="availability-badge__icon">
                                                        {item.availability?.includes("\u274C") ? "\u2717" : "\u2713"}
                                                      </span>
                                                      {item.availability.replace(/[\u274C\u2705]/gu, "").trim()}
                                                    </span>
                                                  )}

                                                </div>
                                                {item?.city && (
                                                  <p className="carousel-city">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className="carousel-city-icon"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" /></svg>
                                                    {item.city}
                                                  </p>
                                                )}

                                                <p className="new_title">{toTitleCase(item?.title)}</p>
                                                
                                                {!item?.price && !item?.additional_amt && (
                                                  <div className="description">{capsToTitleCase(item.subtitle)}</div>
                                                )}

                                                {(item?.price || item?.additional_amt || item?.max_guest_count) && (
                                                  <div className="carousel-price-row">
                                                    <div className="carousel-price-info">
                                                      {item?.price && <span className="carousel-price">{item.price}</span>}
                                                      {item?.additional_amt && (
                                                        <span className="carousel-extra-guest">+₹{item.additional_amt} Extra Guest</span>
                                                      )}
                                                    </div>
                                                    {item?.max_guest_count && (
                                                      <span className="carousel-guest-badge">👥 {item.max_guest_count}  {item.guest_label}</span>
                                                    )}
                                                  </div>
                                                )}

                                                <div className="chatbot_message_btn">
                                                  {item?.buttons?.map(
                                                    (buttonData, buttonIndex) => {
                                                      const isSelected = selectedButtons[message.timestamp] === buttonData.title;
                                                      const isAnySelected = selectedButtons[message.timestamp] !== undefined || message.timestamp <= lastSentTimestamp;
                                                      return (
                                                        <button
                                                          key={buttonIndex}
                                                          className={`chatbot_message_subbtn_inactive button-2  carousel-bot-btn ${isSelected ? "active" : ""}`}
                                                          onClick={(e) => {
                                                            handleButtonClick(buttonData?.payload, buttonData?.title, message.timestamp, buttonData?.type, buttonData?.url);
                                                          }}
                                                        // disabled={isAnySelected}
                                                        >
                                                          {/* {buttonData?.title} */}
                                                          {getButtonIcon(buttonData?.payload, buttonData?.title)}
                                                        </button>
                                                      )
                                                    }
                                                  )}
                                                </div>
                                              </div>
                                            )
                                          )}
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}

                                {message?.text ? (
                                  <>
                                    <div className="breaking">
                                      {/* <div className="bot_message_container_for_img">
                        <div className="chating_right_cover_for_img">
                          <img src={layoutImg} className="inside_layout_img" />

                          <div>
                            <h5>First text goes here</h5>
                            <p>
                              Second text goes heregoes here goes heregoes
                              heregoes heregoes heregoes heregoes heregoes here
                            </p>
                          </div>
                          <div className="chatbot_message_btn">
                            <button
                              className={`chatbot_message_subbtn_inactive button-2 ${
                                isActive ? "active" : ""
                              }`}
                              onClick={handleClick}
                            >
                              one
                            </button>
                            <button
                              className={`chatbot_message_subbtn_inactive button-2 ${
                                isActive ? "active" : ""
                              }`}
                              onClick={handleClick}
                            >
                              two
                            </button>
                            <button
                              className={`chatbot_message_subbtn_inactive button-2 ${
                                isActive ? "active" : ""
                              }`}
                              onClick={handleClick}
                            >
                              three
                            </button>
                          </div>
                        </div>
                        <div>
                          <span className="chating_right_cover_span">
                            12:30pm
                          </span>
                        </div>
                      </div> */}

                                      <div className="bot_message_container">
                                        <div className="chating_right_cover">
                                          {(() => {
                                            const videoInfo = extractVideoInfo(message?.text);
                                            if (videoInfo.hasVideo) {
                                              // Show inline iframe video player
                                              const embedUrl = `https://www.youtube.com/embed/${videoInfo.videoId}`;
                                              return (
                                                <div className="video-container-inline">
                                                  <iframe
                                                    src={embedUrl}
                                                    style={{
                                                      width: '100%',
                                                      height: '180px',
                                                      border: 'none',
                                                      borderRadius: '8px'
                                                    }}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowFullScreen
                                                    title="Video Player"
                                                  />
                                                </div>
                                              );
                                            }
                                            return (
                                              <div className="markdown-body">
                                                <Markdown
                                                  remarkPlugins={[remarkGfm]}
                                                  components={{
                                                    a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }} />
                                                  }}
                                                >
                                                  {capsToTitleCase(message?.text)}
                                                </Markdown>
                                              </div>
                                            );
                                          })()}
                                          <div className="chatbot_message_btn">
                                            {message?.data?.quick_replies?.map(
                                              (reply, replyIndex) => {
                                                const isSelected = selectedButtons[message.timestamp] === reply.title;
                                                const isAnySelected = selectedButtons[message.timestamp] !== undefined || message.timestamp <= lastSentTimestamp;
                                                return (
                                                  <React.Fragment key={replyIndex}>
                                                    {" "}
                                                    {/* <div className="btn-div-bot-reply"> */}
                                                    {reply?.content_type ===
                                                      "text" ? (
                                                      <button
                                                        ref={buttonRef}
                                                        className={`chatbot_message_subbtn_inactive button-2 ${isSelected ? "active" : ""
                                                          }`}
                                                        onClick={() => {
                                                          setIsOpen(false);
                                                          // Update speech-recognition language
                                                          if (languageMap[reply?.payload]) {
                                                            setLang(languageMap[reply?.payload]);
                                                          }
                                                          // Sync i18next language from select_language payload
                                                          const langMatch = reply?.payload?.match(/"language"\s*:\s*"([^"]+)"/);
                                                          if (langMatch) {
                                                            const rasaLang = langMatch[1].toLowerCase();
                                                            const i18nCode = RASA_LANG_MAP[rasaLang];
                                                            if (i18nCode) i18n.changeLanguage(i18nCode);
                                                          }
                                                          scrollToBottom();
                                                          handleButtonClick(reply.payload, reply.title, message.timestamp, reply.type, reply.url);
                                                        }}
                                                        disabled={isAnySelected}
                                                      >
                                                        {/* Show icon only if not selected */}
                                                        {/* {!isSelected && <>{getButtonIcon(reply.title)}</>} */}
                                                        {getButtonIcon(reply.payload, reply.title)}

                                                        {/* {reply?.title} */}
                                                      </button>
                                                    ) : (
                                                      <p className="d-none-else"></p>
                                                    )}
                                                  </React.Fragment>
                                                )
                                              }
                                            )}
                                          </div>
                                        </div>
                                        <div>
                                          <span className="chating_right_cover_span">
                                            {message?.time}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              //console.log("Rendering message item:", message),
                              //console.log("Message text type:", typeof message?.text),
                              //console.log("Message data:", message?.data),
                              <div className="allign_left" key={index}>
                                <div>
                                  <div className="bot_message_container">
                                    <div className="chating_left_cover">
                                      <div className="markdown-body">
                                        <Markdown
                                          remarkPlugins={[remarkGfm]}
                                          components={{
                                            a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', textDecoration: 'underline' }} />
                                          }}
                                        >
                                          {message?.text}
                                        </Markdown>
                                        {/* DEBUG: Temporary view to inspect raw data */}

                                      </div>
                                    </div>
                                    <div className="span_allign">
                                      <span className="chating_left_cover_span">
                                        {message?.time}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ))}
                        {/* </div> */}
                      </div>
                    </div>

                    {/* ITINERARY DATE PICKER */}
                    {showDatePicker && (
                      <div className="itinerary-datepicker-bubble">
                        <div className="itinerary-datepicker-header">{t('datePicker.title')}</div>
                        <div className="itinerary-datepicker-row">
                          <div className="itinerary-datepicker-field">
                            <label>{t('datePicker.from')}</label>
                            <DatePicker
                              selected={dpStartDate}
                              onChange={(date) => {
                                setDpStartDate(date);
                                if (dpEndDate && date > dpEndDate) setDpEndDate(null);
                              }}
                              selectsStart
                              startDate={dpStartDate}
                              endDate={dpEndDate}
                              minDate={new Date()}
                              placeholderText={t('datePicker.placeholder')}
                              dateFormat="yyyy/MM/dd"
                              className="itinerary-dp-input"
                              calendarClassName="itinerary-dp-calendar"
                              formatWeekDay={(day) => day.charAt(0)}
                              popperPlacement="top-start"
                              onChangeRaw={(e) => e.preventDefault()}
                            />
                          </div>
                          <div className="itinerary-datepicker-field">
                            <label>{t('datePicker.to')}</label>
                            <DatePicker
                              selected={dpEndDate}
                              onChange={(date) => setDpEndDate(date)}
                              selectsEnd
                              startDate={dpStartDate}
                              endDate={dpEndDate}
                              minDate={dpStartDate || new Date()}
                              placeholderText={t('datePicker.placeholder')}
                              dateFormat="yyyy/MM/dd"
                              className="itinerary-dp-input"
                              calendarClassName="itinerary-dp-calendar"
                              formatWeekDay={(day) => day.charAt(0)}
                              popperPlacement="top-start"
                              onChangeRaw={(e) => e.preventDefault()}
                            />
                          </div>
                        </div>
                        <div className="itinerary-datepicker-actions">
                          <button
                            className="itinerary-dp-cancel"
                            onClick={() => {
                              setShowDatePicker(false);
                              setDpStartDate(null);
                              setDpEndDate(null);
                              if (dpCancelPayload) {
                                handleButtonClick(dpCancelPayload, t('datePicker.cancel'), Date.now());
                              }
                            }}
                          >
                            {t('datePicker.cancel')}
                          </button>
                          <button
                            className="itinerary-dp-confirm"
                            disabled={!dpStartDate || !dpEndDate}
                            onClick={() => {
                              const fmt = (d) =>
                                `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
                              const startStr = fmt(dpStartDate);
                              const endStr = fmt(dpEndDate);
                              const displayText = `${startStr} to ${endStr}`;
                              const payload = `/provide_dates{"start_date":"${startStr}","end_date":"${endStr}"}`;
                              setShowDatePicker(false);
                              handleButtonClick(payload, displayText, Date.now());
                            }}
                          >
                            {t('datePicker.confirm')}
                          </button>
                        </div>
                      </div>
                    )}

                    <div className="main_footer">
                      <div className="chating_footer_Container">
                        <div className="chating_footer">
                          <div className="footer_allign_center">
                            <textarea
                              className={`chating_body_new${showDatePicker ? ' input-disabled-datepicker' : ''}`}
                              value={input + interimText}
                              disabled={showDatePicker}
                              onChange={(e) => {
                                setIsOpen(false);

                                if (listen) {
                                  setInput(e.target.value);
                                }
                                setInput(e.target.value);
                                e.target.value !== ""
                                  ? setIsShow(true)
                                  : setIsShow(false);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  setListening1(false)
                                  recognition.stop();
                                  e.preventDefault(); // Prevent default form submission behavior
                                  handleSend(e); // Call handleFormSubmit when Enter is pressed
                                }
                              }}
                              placeholder="Send your message here..."
                            />

                            {isShow && !showDatePicker ? (
                              <img
                                src={sendIcon}
                                onClick={(e) => handleSend(e)}
                                alt="send Icon"
                                className="send_icon"
                              />
                            ) : (
                              <div >
                                {/* <FontAwesomeIcon
                                className="mic_icon"
                                icon={
                                  listening1 ? faMicrophoneSlash : faMicrophone
                                }
                                onClick={handleStartStop}
                              /> */}
                                <img
                                  src={sendIcon}
                                  onClick={(e) => handleSend(e)}
                                  alt="send Icon"
                                  className="send_icon"
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="chating_headers">
                  <div className="chating">
                    <div className="initial_icon_res">
                      <img src={chatbotIcon} className="ttdc_icon" alt="" />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={handleChatbotOpen}
                        className="close-icon-top"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="white"
                          d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
                        />
                      </svg>
                    </div>
                    <div className="space_for_subdiv">
                      <h5>Welcome to Tamilnadu Tourism</h5>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
        {/* <footer>
        <div class="wave"></div>
        <div class="footer-content">
            <p>© 2024 Your Company. All rights reserved.</p>
        </div>
    </footer> */}
      </div>
    </div>
  );
};

export default Chatbot;
